/**
 * Shared Indian mobile input helpers for admin forms.
 * Matches: type=tel, maxlength=10, pattern=[6-9][0-9]{9}
 */
export const PHONE_MAX_LENGTH = 10;
export const PHONE_PATTERN = '[6-9][0-9]{9}';
export const PHONE_PATTERN_RE = /^[6-9][0-9]{9}$/;

export function normalizePhoneInput(value) {
  return String(value || '')
    .replace(/\D/g, '')
    .slice(0, PHONE_MAX_LENGTH);
}

export function isValidPhoneInput(value) {
  const digits = normalizePhoneInput(value);
  return digits.length === PHONE_MAX_LENGTH && PHONE_PATTERN_RE.test(digits);
}

export const phoneInputProps = {
  type: 'tel',
  name: 'phone',
  inputMode: 'numeric',
  maxLength: PHONE_MAX_LENGTH,
  pattern: PHONE_PATTERN,
  autoComplete: 'tel-national'
};
